"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimblepulse = void 0;
const sp10_1 = require("../sp10/sp10");
const Pulse_P_Rev_35x42_png_1 = __importDefault(require("./logo/Pulse_P_Rev_35x42.png"));
const Pulse_Logo_Line_Rev_277x36_png_1 = __importDefault(require("./logo/Pulse_Logo_Line_Rev_277x36.png"));
const Pulse_P_103x125_png_1 = __importDefault(require("./logo/Pulse_P_103x125.png"));
const Pulse_P_png_1 = __importDefault(require("./logo/Pulse_P.png"));
const Pulse_Logo_580x194_png_1 = __importDefault(require("./logo/Pulse_Logo_580x194.png"));
const favicon_ico_1 = __importDefault(require("./logo/favicon.ico"));
exports.trimblepulse = {
    ...sp10_1.sp10,
    name: "Trimble Pulse",
    "msi-color": "#005595",
    "loading-dots-color": "#1b5696",
    "banner-background-color": "#111111",
    "drawer-selected-background-color": "#333333",
    "login-header-logo-url": Pulse_Logo_Line_Rev_277x36_png_1.default,
    "login-logo-url": Pulse_P_103x125_png_1.default,
    "app-logo-url": Pulse_P_Rev_35x42_png_1.default,
    "app-logo-color-url": Pulse_P_png_1.default,
    "app-logo-tagline-url": Pulse_Logo_580x194_png_1.default,
    favicon: favicon_ico_1.default
};
//# sourceMappingURL=trimblepulse.js.map